import React from 'react';

import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { linkTo } from '@storybook/addon-links';

import { Welcome } from '@storybook/react/demo';
import { OtherFilings } from './OtherFilings';


  storiesOf('Case Menu/Other Filings', module)

  .add('Showing', () =>
    <div>
      <h3> Other Filings view wth data </h3>
      <hr/>
      <OtherFilings
        otherFilings={otherFilings.data.other_filings}
      />
    </div>
  )
  .add('Empty', () => (
    <div>
      <h3> Other FilingsCases Empty</h3>
      <hr/>
      <OtherFilings
        otherFilings={otherFilingsEmpty.data.other_filings}
      />
    </div>
  ))

  const otherFilings= {
    data: {
      other_filings: [
      {
        case : {
          case_code: "15-32192-rld7",
          case_id: "465340",
          case_name: "Jamie Lynn Smith and Billy Ruben Smith",
          case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?465340",
          case_uuid: "orbke_465340",
        },
        debtor: {
          name: "Billy Ruben Smith"
        },
      },
      {
        case : {
          case_code: "15-32192-rld7",
          case_id: "465340",
          case_name: "Jamie Lynn Smith and Billy Ruben Smith",
          case_title: "Jamie Lynn Smith and Billy Ruben Smith",
          case_uri: "https://ecf.orb.uscourts.gov/cgi-bin/DktRpt.pl?465340",
          case_uuid: "orbke_465340",
        },
        debtor: {
          name: "Jamie Lynn Smith"
        },
      },
    ]
   }
 }

  const otherFilingsEmpty= {
    data: {
      other_filings: {
         'empty' : "There Are No Case Filing Associations For This Case. "
       },
    }
  }




// WEBPACK FOOTER //
// ./src/components/case/associated_cases/OtherFilings.stories.jsx